(function () {
    'use strict';

    angular
        .module('services')
        .service('EdufindmeReportService', EdufindmeReportService);

    EdufindmeReportService.$inject = ['$http', 'API_BASE'];

    function EdufindmeReportService($http, API_BASE) {
        var service = this;

        service.getClientStatistics = getClientStatistics;
        service.accountDeleteRequest = accountDeleteRequest;

        function getClientStatistics(data, page) {
            return $http.get(API_BASE + '/edufindme/reports/clientStatistics', {
                params: {
                    type: data['type'],
                    name: data['name'],
                    plans: data['plans'],
                    expires_in: data['expires_in'],
                    page: page
                }
            });
        }

        function accountDeleteRequest(id) {
            return $http.post(API_BASE + '/edufindme/account/delete-request', { id: id });
        }
    }
})();